import invariant from 'tiny-invariant'

import { buildCompanyCompassInviteUrl } from '../lib/helpers/routeHelpers'
import useCurrentCompanyOrFail from './useCurrentCompanyOrFail'

export function useCompanyCompassLink() {
  const currentCompany = useCurrentCompanyOrFail()
  const referralCode = currentCompany.referralCode

  invariant(referralCode, 'Could not find referral code for current company.')

  return `${window.location.origin}${buildCompanyCompassInviteUrl(
    referralCode,
  )}`
}
